/**
 * Cart quantity: pressing minus removes the entire line item instead of
 * decrementing by 1. Cart quantity inputs are not manually editable.
 */
(function () {
  if (window.__bogoCartQtyInitialized) return;
  window.__bogoCartQtyInitialized = true;

  const MINUS_SELECTOR =
    'quantity-input .quantity__button[name="minus"], quantity-input .quantity__button--minus';

  const CART_QTY_INPUT_SELECTOR =
    'cart-drawer-items .quantity__input-cart, cart-drawer-items .quantity__input, cart-items .quantity__input';

  function lockCartQuantityInput(input) {
    if (!input || input.dataset.qtyLocked === 'true') return;

    input.dataset.qtyLocked = 'true';
    input.readOnly = true;
    input.setAttribute('readonly', 'readonly');
    input.setAttribute('tabindex', '-1');
    input.setAttribute('aria-readonly', 'true');
  }

  function lockCartQuantityInputs(root) {
    (root || document).querySelectorAll(CART_QTY_INPUT_SELECTOR).forEach(lockCartQuantityInput);
  }

  function blockManualQuantityEdit(event) {
    const input = event.target.closest(CART_QTY_INPUT_SELECTOR);
    if (!input) return;

    event.preventDefault();
  }

  function removeCartLineItem(cartItem) {
    const lineIndex = cartItem.dataset.index;
    if (!lineIndex) return;

    const cartItems =
      cartItem.closest('cart-drawer-items') || cartItem.closest('cart-items');

    if (cartItems && typeof cartItems.updateQuantity === 'function') {
      cartItems.updateQuantity(lineIndex, 0);
      return;
    }

    const removeButton = cartItem.querySelector('cart-remove-button button, cart-remove-button a');
    if (removeButton) {
      removeButton.click();
      return;
    }

    fetch(window.routes?.cart_change_url || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(lineIndex, 10), quantity: 0 }),
    }).then(function () {
      window.location.reload();
    });
  }

  lockCartQuantityInputs();

  ['keydown', 'paste', 'drop', 'wheel'].forEach(function (eventName) {
    document.addEventListener(eventName, blockManualQuantityEdit, true);
  });

  document.addEventListener(
    'click',
    function (event) {
      const minusButton = event.target.closest(MINUS_SELECTOR);
      if (!minusButton) return;

      const cartItem = minusButton.closest('.cart-item, .cart-drawer-item');
      if (!cartItem) return;

      if (cartItem.dataset.removing === 'true') {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      cartItem.dataset.removing = 'true';
      removeCartLineItem(cartItem);
    },
    true
  );

  const cartObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        lockCartQuantityInputs(node);
      });
    });
  });

  function observeCart() {
    document.querySelectorAll('cart-drawer-items, cart-items').forEach(function (cartRoot) {
      cartObserver.observe(cartRoot, { childList: true, subtree: true });
      lockCartQuantityInputs(cartRoot);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeCart);
  } else {
    observeCart();
  }

  document.addEventListener('cartQuantityUpdated', function () {
    lockCartQuantityInputs();
  });
})();
